<div class="freetrial">
    <p-button
        icon="ms ms-close"
        severity="secondary"
        [rounded]="true"
        [ariaLabel]="'common.close_button' | translate"
        class="freetrial__close"
        (onClick)="close()" />
    <div class="freetrial__waves">
        <svg
            class="curveTop-1"
            width="100%"
            height="auto"
            viewBox="0 0 1248 309"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin slice">
            <path
                d="M1248 0.52002H0V308.323C464.875 58.3496 1025.7 71.097 1248 108.717V0.52002Z"
                [attr.fill]="mainColor" />
        </svg>
        <svg
            class="curveTop-2"
            width="100%"
            height="auto"
            viewBox="0 0 1248 309"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin slice">
            <path
                d="M1248 0.52002H0V308.323C464.875 58.3496 1025.7 71.097 1248 108.717V0.52002Z"
                [attr.fill]="mainColor"
                opacity="0.8" />
        </svg>
        <svg
            class="curveTop-3"
            width="100%"
            height="auto"
            viewBox="0 0 1248 309"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMinYMin slice">
            <path
                d="M1248 0.52002H0V308.323C464.875 58.3496 1025.7 71.097 1248 108.717V0.52002Z"
                [attr.fill]="mainColor"
                opacity="0.4" />
        </svg>
    </div>
    <div class="freetrial__body">
        <h2 class="freetrial__title">{{ 'common.freetrialExpire.title' | translate }}</h2>
        <p class="m-0">{{ 'common.freetrialExpire.description' | translate }}</p>
        <p-button
            class="align-self-start"
            [label]="'common.freetrialExpire.button' | translate"
            (onClick)="onClickContactUs()" />
    </div>
</div>
